import { ModalService } from '@app/plugins/iview-modal-modify/service';
import { VoiceService } from '@voice/services/VoiceService';
import ItemForm from '@voice/components/modal-export-detailed-form';
import i18n from '@app/plugins/i18n';

class ExportModalService extends ModalService {
  constructor() {
    super(VoiceService);
  }

  create(trunks) {
    return this.$open({
      title: i18n.t('shared.component.modal.export'),
      width: this.size.large,
      loading: true,
      render: (h) =>
        h(ItemForm, {
          props: { trunks },
          on: {
            success: (data) => {
              this.$emit('success', data);
              this.modal.remove();
            }
          }
        })
    });
  }
}

const instance = new ExportModalService();
export { instance as ExportModalService };
